// Single source of truth for the app's pages. Both Navbar (breadcrumb text)
// and SubmitFeedbackDialog (the "Which Page?" dropdown) read from here, so a
// new route only has to be added in one place. TRADE-883 and TRADE-1000 both
// regressed because the dropdown drifted from the routed page list.

// Breadcrumb text shown by Navbar for each route. text "None" hides the
// breadcrumb (used for routes Navbar treats specially, e.g. /payment and
// /upgradeaccount switch into hideNavbar mode based on this text).
export const PAGE_NAME = [
  { page: "/login", text: "None" },
  { page: "/signup", text: "None" },
  { page: "/logTrade", text: "None" },
  { page: "/home", text: "Home" },
  { page: "/PnlCalendar", text: "PnL Calendar" },
  { page: "/summary", text: "Trade Summary" },
  { page: "/ticker-analytics", text: "Ticker Analytics" },
  { page: "/tag-analytics", text: "Tag Analytics" },
  { page: "/options-analytics", text: "Options Analytics" },
  { page: "/emotional-analytics", text: "Emotional Analytics" },
  { page: "/insights", text: "Insights" },
  { page: "/study", text: "Study" },
  { page: "/journal", text: "Journal" },
  { page: "/leaderboard", text: "Leaderboard" },
  { page: "/groups", text: "Groups" },
  { page: "/profile", text: "User Profile" },
  { page: "/myfeedback", text: "My Feedback" },
  { page: "/payment", text: "Payment" },
  { page: "/upgradeaccount", text: "Upgrade Account" },
];

// Labels for the Submit Feedback "Which Page?" dropdown. Derived from
// PAGE_NAME (skipping text "None" breadcrumb-hidden entries) and topped
// with the auth / log-trade / public-profile routes the dropdown has
// historically surfaced. "Other" is the trailing sentinel.
export const FEEDBACK_PAGE_OPTIONS = [
  "Login",
  "Signup",
  "Log Trade",
  ...PAGE_NAME.filter((p) => p.text !== "None").map((p) => p.text),
  "Public Profile",
  "Other",
];
